<template>
  <div v-if="visible" class="kwic kwic-with-header">
    <ncs-empty-result v-if="emptyResult"/>
    <template v-else>
      <ncs-page-selector/>
      <ncs-fixed-column-table :center="true">
        <table class="table table-striped table-borderless table-sm">
          <tbody ref="tableBody">
          <template v-for="(row, index) in result.kwic">
            <tr class="kwic-header-row" :class="{odd: index % 2 === 1}" v-if="headerVisible">
              <td colspan="4">
                <context-header :document="row.document" :text="row.text" :elements="row.elements"/>
              </td>
            </tr>
            <ncs-kwic-result-row :index="currentOffset + index + 1" :row="row" :class="{odd: index % 2 !== 1}"/>
          </template>
          </tbody>
        </table>
      </ncs-fixed-column-table>
      <ncs-page-selector/>
    </template>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import Ncs from 'ncs'
  import ContextHeader from './ContextHeader'

  // This component handles kwic and kwic_with_header result display.
  // They could be implemented as separated components, but they are very similar.
  // Having them implemented in the same component makes the change from kwic to
  // kwic_with_header quicker, since a full component render is not needed.
  export default {
    extends: Ncs.defaultComponents.NcsKwicResult,
    components: {ContextHeader},
    computed: {
      ...mapState({
        headerVisible: s => s.api.resultDisplay === 'kwic_with_header',
        visible: s => s.api.resultDisplay === 'kwic' || s.api.resultDisplay === 'kwic_with_header'
      }),
    },
  }
</script>